import { UserFull } from '@wellesley/openapi'

export const filterValidUsers = (users: UserFull[]) => {
  return users.filter((user) => user.id && user.username && user.displayName)
}
